import { useState, type FormEvent } from "react";
import { useAuth } from "../hooks/AuthContext";

export function Login() {
  const { login, error } = useAuth();
  const [secret, setSecret] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(secret);
    } catch {
      // error state is already surfaced via useAuth().error
    } finally {
      setSubmitting(false);
      setSecret("");
    }
  }

  return (
    <div className="login-shell">
      <div className="login-card">
        <div className="brand" style={{ justifyContent: "center", marginBottom: "var(--space-6)" }}>
          <div className="brand-mark" />
          <span className="brand-name">Fleet Console</span>
        </div>

        <div className="panel">
          <h1 style={{ marginBottom: "4px" }}>Administrator sign-in</h1>
          <p className="muted" style={{ marginBottom: "var(--space-5)", fontSize: "13px" }}>
            Enter the administrator secret configured for this deployment.
          </p>

          <form onSubmit={handleSubmit}>
            {error && <div className="form-error">{error}</div>}

            <div className="form-group">
              <label htmlFor="admin-secret">Administrator secret</label>
              <input
                id="admin-secret"
                className="input"
                type="password"
                autoComplete="current-password"
                value={secret}
                onChange={(e) => setSecret(e.target.value)}
                placeholder="••••••••••••"
                required
                autoFocus
              />
            </div>

            <button type="submit" className="btn btn-primary" style={{ width: "100%" }} disabled={submitting || secret.length === 0}>
              {submitting ? "Signing in…" : "Sign in"}
            </button>
          </form>
        </div>

        <p className="faint" style={{ textAlign: "center", marginTop: "var(--space-4)", fontSize: "12px" }}>
          This secret is never stored in the browser; it is checked once against a Cloudflare secret and exchanged for a session.
        </p>
      </div>
    </div>
  );
}
